// External Dependencies
import React, { useEffect, useState } from 'react'

// API Services
import axiosInterceptorInstance from '../../utils/axios/axiosInterceptorInstance'

// Components
import CustomToast from '../../components/Custom/CustomToast'

// Constants for material categories
const MATERIAL_CATEGORIES = [
  'Stone',
  'Brick',
  'Wood',
  'Terrazzo',
  'Concrete',
  'Metal',
  'Tile',
  'Fabric',
  'Wallpaper',
  'Carpet',
  'Surfaces',
  'Plastic',
  'Finishes',
  'Organic',
  'Acoustic',
  'Insulation',
  'Landscaping',
]

const Home = () => {
  // State Management
  const [isLoading, setIsLoading] = useState(true)
  const [materials, setMaterials] = useState([])
  const [pattern, setPatterns] = useState(0)

  const fetchMaterials = async () => {
    setIsLoading(true)
    try {
      const response = await axiosInterceptorInstance.get(
        '/materials/statistics',
      )

      if (response?.data) {
        setMaterials(response.data.materialStats || [])
        setPatterns(response.data.patternStats || 0)
      } else {
        throw new Error('Invalid response format')
      }
    } catch (error) {
      CustomToast({
        message: 'Failed to fetch statistics. Please try again.',
        type: 'error',
      })
    } finally {
      setIsLoading(false)
    }
  }

  // Fetch data on component mount
  useEffect(() => {
    fetchMaterials()
  }, [])

  const StatisticsCard = ({ count, category }) => (
    <div className='py-8 px-2 rounded shadow border bg-prime/80'>
      <h6 className='font-bold text-3xl'>{count}</h6>
      <h3 className='font-semibold text-lg'>{category || 'Category'}</h3>
    </div>
  )

  const getMaterialCount = (category) => {
    const material = materials.find((m) => m.category === category)
    return material ? material.totalMaterials : 0
  }

  if (isLoading) {
    return <p className='text-center my-20'>Loading statistics...</p>
  }

  return (
    <div className='space-y-8'>
      <section>
        <h2 className='my-4 font-bold text-xl'>Materials</h2>
        <div className='grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-4 my-8 text-center text-white'>
          {MATERIAL_CATEGORIES.map((category, index) => (
            <StatisticsCard
              key={index}
              count={getMaterialCount(category)}
              category={category}
            />
          ))}
        </div>
      </section>

      <section>
        <h2 className='my-4 font-bold text-xl'>Joints</h2>
        <div className='grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-4 my-8 text-center text-white'>
          <StatisticsCard count={getMaterialCount('Joint')} category='Joint' />
        </div>
      </section>

      {/* Patterns Section */}
      <section>
        <h2 className='my-4 font-bold text-xl'>Patterns</h2>
        <div className='grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-4 my-8 text-center text-white'>
          <StatisticsCard count={pattern} category='Pattern' />
        </div>
      </section>
    </div>
  )
}

export default Home
